// Identifies whether the widget container holds content beyond the loading placeholder.
// The sentinel attribute [data-precheckin-loading-placeholder] is owned by PrecheckinWidget
// and stable regardless of changes to ContentLoader's internal test attributes.
export function getHasVisibleContent(container: HTMLDivElement): boolean {
  return Array.from(container.children).some(
    child => !(child as HTMLElement).matches('[data-precheckin-loading-placeholder]')
  );
}
